// eslint-disable-next-line import/prefer-default-export
export const GIG_STATUSES = {
    open: 'open',
    draft: 'draft',
    expired: 'expired'
}